import React, { useState } from "react";

const MARK_SRC = `${process.env.PUBLIC_URL || ""}/nexxis-NLogo-removebg-preview.png`;

// Fallback SVG mark (used until /public/nexxis-mark.png exists, or if it fails
// to load). Uses currentColor so it stays adaptive over any background.
const SvgMark = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <path
      d="M10 4 L10 36 L16 36 L16 16 L26 36 L32 36 L32 4 L26 4 L26 24 L16 4 Z"
      fill="currentColor"
    />
    <polygon points="16,19 16,36 25,36" fill="#FF6857" />
  </svg>
);

/*
 * LogoMark — the real "N" mark (public/nexxis-mark.png, transparent). On teal /
 * dark backgrounds it's recoloured to white via CSS (.nxx-logo-mark.is-light /
 * [data-theme=dark]). Falls back to an adaptive SVG if the image is missing.
 */
export const LogoMark = ({ size = 28, light = false, className = "" }) => {
  const [err, setErr] = useState(false);
  if (err) {
    return (
      <span className={className} style={{ display: "inline-flex", lineHeight: 0 }}>
        <SvgMark size={size} />
      </span>
    );
  }
  return (
    <img
      src={MARK_SRC}
      alt="NEXXIS"
      onError={() => setErr(true)}
      draggable={false}
      className={`nxx-logo-mark ${light ? "is-light" : ""} ${className}`}
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
    />
  );
};

export const Wordmark = ({ size = 22, color = "currentColor" }) => (
  <span
    className="font-display"
    style={{
      fontSize: size,
      letterSpacing: "0.16em",
      fontWeight: 600,
      color,
      lineHeight: 1,
    }}
  >
    NEXXIS
  </span>
);

export const NexxisLogo = ({ markSize = 26, wordSize = 18, color, light = false }) => (
  <div className="flex items-center gap-2.5" style={{ color }}>
    <LogoMark size={markSize} light={light} />
    <Wordmark size={wordSize} color="currentColor" />
  </div>
);

const FULL_SRC = `${process.env.PUBLIC_URL || ""}/nexxis-new-noBG.png`;

/*
 * FullLogo — the complete horizontal lockup (mark + NEXXIS + tagline). Recoloured
 * to white over teal/dark via .nxx-logo-mark; falls back to mark + wordmark.
 */
export const FullLogo = ({ height = 34, light = false }) => {
  const [err, setErr] = useState(false);
  if (err) {
    return (
      <span className="flex items-center gap-2.5">
        <LogoMark size={Math.round(height * 0.8)} light={light} />
        <Wordmark size={Math.round(height * 0.5)} color="currentColor" />
      </span>
    );
  }
  return (
    <img
      src={FULL_SRC}
      alt="NEXXIS — LATAM's Gateway to Global Markets"
      onError={() => setErr(true)}
      draggable={false}
      className={`nxx-logo-mark ${light ? "is-light" : ""}`}
      style={{ height, width: "auto", objectFit: "contain", display: "block" }}
    />
  );
};
